var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9425 2.05625C10.6729 0.7875 8.93058 0 6.99562 0C3.1257 0 0 3.1325 0 7C0 10.8675 3.1257 14 6.99562 14C10.2614 14 12.9844 11.7688 13.7636 8.75H11.9425C11.2245 10.7887 9.2808 12.25 6.99562 12.25C4.09756 12.25 1.74234 9.89625 1.74234 7C1.74234 4.10375 4.09756 1.75 6.99562 1.75C8.44903 1.75 9.74484 2.35375 10.6904 3.3075L7.87117 6.125H14V0L11.9425 2.05625Z",
    fill: "#EDFF8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.5841d9a7937d6d137d97920150b53dda.svg";
export { ForwardRef as ReactComponent };